import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Carousel } from "antd";
import { withRouter, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
//import { Link } from "react-router-dom";
import SearchBarHome from "./SearchBarHome";

class SharedLayout extends Component {
  state = {
    dotPosition: "top",
  };
  getFilters(filters) {
    this.props.stockfilters(filters);
  }

  renderSearchBar() {
    const { dotPosition } = this.state;
    return (
      <div>
        <section className='block-sl desktop-view'>
          <div className='container-custom'>
            <div className='row'>
              <div className='col-sm-5 col-md-5 col-lg-5'>
                <div className='banner-item-home banner-2x-home no-bg color-inher-home'>
                  <h2
                    className='f-weight-600'
                    style={{
                      fontSize: "40px",
                      marginBottom: "-1.4em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <br />
                    FIND A CAR THAT SUITS
                  </h2>
                  <h1 class='title-flip rw-sentence'>
                    <span
                    //style={{ fontFamily: "Caveat" }}
                    >
                      YOUR
                    </span>
                    <span
                      class='rw-words rw-words-1'
                      //style={{ fontFamily: "Caveat" }}
                    >
                      <span class='highlight'>BUDGET</span>
                      <span class='highlight'>LIFESTYLE</span>
                      <span class='highlight'>NEEDS</span>
                      <span class='highlight'>FAMILY</span>
                      <span class='highlight'>FRIENDS</span>
                      <span class='highlight'>SWAG</span>
                    </span>
                  </h1>

                  <p
                    style={{
                      marginBottom: "-1.2em",
                      marginTop: "-1.2em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Mega Theron Group makes it easy to drive your dream car.
                  </p>
                  {/*<Link
                      to={"/stock"}
                      className="ht-btn ht-btn-default ht-btn-2x m-t-lg-35"
                    >
                      View all stock
                    </Link>*/}
                </div>
              </div>
              <Carousel autoplay dotPosition={dotPosition} dots={false}>
                <div className='col-sm-6 col-md-6 col-lg-6'>
                  <img
                    className='banner-img-home'
                    style={{ width: "50em" }}
                    src={`${process.env.PUBLIC_URL}/images/home-banner.png`}
                    alt='logo'
                  />
                </div>{" "}
                {/*<div className='col-sm-6 col-md-6 col-lg-6'>
                  <img
                    className='banner-img-home'
                    style={{ width: "50em" }}
                    src={`${process.env.PUBLIC_URL}/images/home-banner-2.png`}
                    alt='logo'
                  />
                </div>*/}
              </Carousel>
            </div>
          </div>
        </section>{" "}
        <section className='block-sl mobile-view' style={{ width: "100vw" }}>
          <div className='container-custom'>
            <div className='row'>
              <div className='col-sm-5 col-md-5 col-lg-5'>
                <div className='banner-item-home banner-2x-home no-bg color-inher-home'>
                  <h1
                    className='f-weight-600'
                    style={{
                      marginTop: "-1em",
                      fontSize: 40,
                      textAlign: "center",
                      lineHeight: 0.1,
                      marginRight: "-15px",
                      marginLeft: "-15px",
                    }}
                  >
                    <br />
                    PURCHASE YOUR
                    <h1
                      style={{ color: "red", fontSize: 40, marginTop: "0em" }}
                    >
                      <br />
                      PERFECT CAR
                    </h1>
                  </h1>
                  <p style={{ textAlign: "center" }}>
                    Mega Theron Group makes it easy to drive your dream car.
                  </p>
                  {/*<Link
                      to={"/stock"}
                      className="ht-btn ht-btn-default ht-btn-2x m-t-lg-35"
                    >
                      View all stock
                    </Link>*/}
                </div>
              </div>
              <Carousel
                autoplay
                dotPosition={dotPosition}
                dots={false}
                style={{ marginTop: "0em" }}
              >
                <div
                  className='col-sm-6 col-md-6 col-lg-6'
                  style={{ marginTop: "0em" }}
                >
                  <img
                    className='banner-img-home'
                    style={{ width: "100%", paddingTop: 0 }}
                    src={`${process.env.PUBLIC_URL}/images/home-banner.png`}
                    alt='logo'
                  />
                </div>{" "}
                {/*<div className='col-sm-6 col-md-6 col-lg-6'>
                  <img
                    className='banner-img-home'
                    style={{ width: "100%", paddingTop: 0 }}
                    src={`${process.env.PUBLIC_URL}/images/home-banner-2.png`}
                    alt='logo'
                  />
                </div>*/}
              </Carousel>
            </div>
          </div>
        </section>
        <SearchBarHome filters={this.getFilters.bind(this)} />
      </div>
    );
  }
  static propTypes = {
    location: PropTypes.object.isRequired,
  };
  render() {
    const { location } = this.props;
    return (
      <div id='wrap' className='color1-inher'>
        <Header />
        {location.pathname === "/home" || location.pathname === "/"
          ? this.renderSearchBar()
          : null}
        <div id='wrap-body' className='p-t-lg-45'>
          <div className='container-custom'>{this.props.children}</div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(SharedLayout);



// WEBPACK FOOTER //
// ./src/components/SharedLayout.js